export function updateUrlParams (url, newParams) {
  const params = Array.from(newParams)
  // rm existing form values
  for (const name of params.map(arr => arr[0])) {
    url.searchParams.delete(name)
  }

  // add form values
  for (const [name, value] of params) {
    url.searchParams.append(name, value)
  }
  return url
}
